import { cn } from '@/lib/utils';

// Switch control for boolean settings, replacing a true/false <select>.
//
// role="switch" + aria-checked is what screen readers and keyboards expect; a
// native <button> already handles Space/Enter, so no key handling is needed
// here. Rendered without a shadow to match the rest of the operator UI —
// borders and flat fills only.
export function Toggle({
  checked,
  onChange,
  disabled,
  label,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  // Accessible name. The visible label sits next to the switch in the field
  // card, so it is passed here rather than wrapping the control in a <label>.
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full p-0.5 transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 focus-visible:ring-offset-2',
        checked ? 'bg-slate-900' : 'bg-slate-300',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
    >
      <span
        className={cn(
          'pointer-events-none inline-block h-4 w-4 rounded-full bg-white transition-transform',
          checked ? 'translate-x-4' : 'translate-x-0'
        )}
      />
    </button>
  );
}
